export const IMG_PATH = './assets/images/';
export const VDO_PATH = './assets/videos/';
export const FORM_URL = 'https://www.saraju.com/r-about/saraju-form/';
export const MAIN_SITE = 'https://www.saraju.com/';
// export const IMG_PATH = '/assets/images/';
